// DateInput.tsx

import React from "react";

type Props = {
  value?: string;
  onChange: (date: string) => void;
};

export default function DateInput({ value, onChange }: Props) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = e.target.value;
    onChange(newDate);
  };

  return (
    <div>
      <label className="mb-1" htmlFor="sessionDate">
        Filtrer par Jour
      </label>
      <input
        id="sessionDate"
        type="date"
        className="form-control"
        value={value || ""}
        onChange={handleChange}
      />
    </div>
  );
}
